<div class="filter">
  <mat-form-field class="filter__form-field">
    <mat-select #filterSelect [formControl]="selectFormControl" multiple [panelWidth]="300">
      <mat-option>
        <ngx-mat-select-search
          [placeholderLabel]="'Search'"
          [noEntriesFoundLabel]="'No entries found'"
          ngModel
          (ngModelChange)="filterOptions($event)"></ngx-mat-select-search>
      </mat-option>
      <mat-option value="select-all" selectAll [allValues]="data">SELECT ALL</mat-option>
      @for (filter of data; track filter.value) {
        <mat-option [value]="filter.value">
          {{ filter.value | uppercase }}{{ filter.value === 'No value' ? '' : ' (' + filter.count + ')' }}
        </mat-option>
      }
      <div class="filter__action-buttons">
        <button mat-stroked-button (click)="clear()">Clear</button>
        <button mat-flat-button (click)="apply()">Apply</button>
      </div>
    </mat-select>
  </mat-form-field>
  <div class="material-symbols-outlined filter__icon" (click)="filterSelect.toggle(); $event.stopPropagation()">
    @if (numberOfAppliedFilters === 0) {
      filter_list
    } @else if (numberOfAppliedFilters > 9) {
      filter_9_plus
    } @else {
      {{ 'filter_' + numberOfAppliedFilters }}
    }
  </div>
</div>
